import { Flex, IconButton, Menu, MenuButton, MenuItem, MenuList, useDisclosure, useTheme } from '@vitvio/design-system';
import { UserAvatar } from './UserAvatar';
import { UserSettingsModal } from './UserSettingsModal';
import { useKindeAuth } from '@kinde-oss/kinde-auth-react';
import { NavLink } from 'react-router-dom';
import { MISSION_CONTROL_ONLY_FLAG } from '@vitvio/feature-flags';
import { useTranslation } from '@vitvio/locales';
import { mixpanel } from '@vitvio/logging';

export function AvatarMenuWithButton() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { logout, getFlag } = useKindeAuth();
  const { t } = useTranslation();
  const { getColor, getSpacing } = useTheme();
  const missionControlOnly = getFlag?.(MISSION_CONTROL_ONLY_FLAG, false, 'b').value ?? false;

  function handleLogout() {
    mixpanel.track('logout_initiated');
    logout();
  }
  function handleMenuButtonClick() {
    mixpanel.track('account_navigation');
  }
  return (
    <Menu>
      <UserSettingsModal isOpen={isOpen} onClose={onClose} />
      <MenuButton
        as={IconButton}
        onClick={handleMenuButtonClick}
        aria-label={t('common:menu.user')}
        variant="ghost"
        bg={'transparent'}
        _hover={{ bg: 'transparent' }}
        _focus={{ bg: 'transparent' }}
        _active={{ bg: 'transparent' }}
        fontSize={'xl'}
        py={getSpacing('5')}
      >
        <UserAvatar />
      </MenuButton>
      <MenuList bg={getColor('bg.overlay')} borderColor={getColor('border')}>
        {!missionControlOnly && (
          <MenuItem color={getColor('fg')} bg={getColor('bg.overlay')}>
            <NavLink to={'/organization_management'}>{t('common:menu.organizationManagement')}</NavLink>
          </MenuItem>
        )}
        <MenuItem onClick={onOpen} color={getColor('fg')} bg={getColor('bg.overlay')}>
          <Flex gap={getSpacing('9')}>{t('common:menu.settings')}</Flex>
        </MenuItem>
        <MenuItem onClick={handleLogout} color={getColor('fg')} bg={getColor('bg.overlay')}>
          {t('common:menu.logout')}
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
